import Http from "./http";

export const checkDocumentStatusAPI = (data) => {
  return Http.post("checkDocumentStatus",data);
};